import { AP_ACTIVACION_HBO_ALIAS, providers } from "@/constants/constants";
import { SERVICE_SHARED_DATA } from "@/constants/modals";
import { ALIAS_FOOTER_MANAGMENT } from "@/constants/orion";
import {
  getMobilesProducts,
  hiredProductsChecksRulesList,
} from "@/containers/my-products/utils";
import { capitalizeFirstLetter } from "@/utils/htmlUtils";
import mock from "./mocks.json";

/**
 * Función que recibe los fields del api de orion, y mete la informacion necesaria dentro
 * de un array donde estaran los diferentes literales
 * @param {Array} fields
 */
export const getApItem = (fields) => {
  let moduleLiterals = [];
  if (fields && Array.isArray(fields) && fields.length > 0) {
    fields.map((item) => {
      const fieldModule = {
        title: item?.fields?.title,
        subtitle: item?.fields?.subtitle,
        type: item?.fields?.type,
        url: item?.fields?.url,
        labelRight: item?.fields?.labelRight,
        urlText: item?.fields?.urlText,
        subItems: getApItem(item?.fields?.subItems),
        dropdownLabel: item?.fields?.dropdownLabel,
        dropdown: item?.fields?.dropdown,
        hired: item?.fields?.hired,
      };
      moduleLiterals.push(fieldModule);
    });
  }
  return moduleLiterals;
};
/**
 * normalizador modulo de AP_PERFIL
 * @param {object} fields
 * @param {string} module
 * @returns
 */
export const normalizeOrionInfoProfile = (data, module) => {
  try {
    let res = null;
    let texts = [];
    const fields = data?.fields?.[module]?.fields;
    if (fields) {
      const iconProps = { icon: fields?.icon, position: fields?.alignIcon };
      if (fields?.perfilUser) {
        const modules = fields?.perfilUser;
        if (modules && Array.isArray(modules) && modules.length > 0) {
          modules.map((module) => {
            const { fields } = module;
            let moduleLiterals = getApItem(fields.AP_ITEM);
            const moduleNormalize = {
              moduleTitle: fields?.title,
              moduleLiterals,
            };
            texts.push(moduleNormalize);
          });
        }
      } else {
        let moduleLiterals = getApItem(fields.AP_ITEM);
        const moduleNormalize = {
          moduleTitle: fields?.title,
          moduleLiterals,
        };
        texts.push(moduleNormalize);
      }
      res = {
        iconProps,
        texts,
      };
    }
    return res;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const normalizerManagamentPagesOrion = (data, hiredProductsList) => {
  const sectionsOrion = [];
  const moduleAlias = [
    "000_MODULO_GESTIONES",
    "000_MODULO_OTRAS_GESTIONES",
    "004_AP_MODULO_OTRAS_GESTIONES",
  ];

  moduleAlias.map((module) => {
    if (data?.fields?.[module]?.fields) {
      const fields = data?.fields?.[module]?.fields;
      const normalizerManagment = [];
      fields?.faqsList.map((item) => {
        if (
          hiredProductsChecksRulesList(hiredProductsList, item.fields.rulesList)
        ) {
          const field = {
            href: item?.fields?.href,
            icon: item?.fields?.icon,
            title: item?.fields?.title,
            subtitle: item?.fields?.subtitle,
          };
          normalizerManagment.push(field);
        }
      });
      sectionsOrion.push({
        name: data?.fields?.[module]?.name,
        title: fields?.title,
        subtitle: fields?.subtitle,
        listManagment: normalizerManagment,
      });
    }
  });

  return sectionsOrion;
};

export const normalizerGeneralManagamentPagesOrion = (data) => {
  const sectionsOrion = [];
  const moduleAlias = [
    "000_AP_MODULO_GESTIONES",
    "001_AP_MODULO_OTRAS_GESTIONES",
  ];

  moduleAlias.map((module) => {
    if (data?.fields?.[module]?.fields) {
      const fields = data?.fields?.[module]?.fields;
      const normalizerManagment = [];
      fields?.faqsList.map((item) => {
        const field = {
          href: item?.fields?.href,
          icon: item?.fields?.icon,
          srcSvg: item?.fields?.srcSvg,
          title: item?.fields?.title,
          subtitle: item?.fields?.subtitle,
          alias: item?.alias,
          serviceType: item?.fields?.serviceType,
          modalContent: {
            alias: item?.fields?.modalContent?.alias,
            title: item?.fields?.modalContent?.title,
            data: item?.fields?.modalContent?.data?.fields,
            subtitle: item?.fields?.modalContent?.subtitle,
          },
        };
        field && field.serviceType && !field.serviceType.includes("-app") && normalizerManagment.push(field);
      });
      sectionsOrion.push({
        name: data?.fields?.[module]?.name,
        title: fields?.title,
        subtitle: fields?.subtitle,
        listManagment: normalizerManagment,
      });
    }
  });
  if (data?.fields?.["002_AP_MODULO_HREF_TITLE"]?.fields) {
    const moduleFields = data?.fields?.["002_AP_MODULO_HREF_TITLE"]?.fields;
    sectionsOrion.push({
      name: ALIAS_FOOTER_MANAGMENT,
      title: moduleFields?.title,
      button: moduleFields?.button,
      href: moduleFields?.href,
      label1:
        moduleFields.hreftitleList &&
        moduleFields.hreftitleList[0] &&
        moduleFields.hreftitleList[0]?.fields?.title,
      link1:
        moduleFields.hreftitleList &&
        moduleFields.hreftitleList[0] &&
        moduleFields.hreftitleList[0]?.fields?.href,
      label2:
        moduleFields.hreftitleList &&
        moduleFields.hreftitleList[1] &&
        moduleFields.hreftitleList[1]?.fields?.title,
      link2:
        moduleFields.hreftitleList &&
        moduleFields.hreftitleList[1] &&
        moduleFields.hreftitleList[1]?.fields?.href,
    });
  }

  return sectionsOrion;
};

const normalizerHiredProductsOrion = (data, module, object) => {
  const cardList = data?.fields?.[module]?.fields?.[object] || [];
  const normalizedCardList = cardList.map((card) => ({
    name: card.fields.name,
    alias: card.alias,
    icon: card.fields.icon,
    url: card.fields.url,
    showDetail: card.fields.showDetail === "true" ? true : false,
    rulesList: card.fields.rulesList.map((rule) => ({
      poId: rule.fields.poId,
      productOfferingTypes: rule.fields?.productOfferingTypes,
      productType: rule.fields.productType,
      subseccion: rule.fields.subseccion,
    })),
  }));
  return normalizedCardList;
};

const normalizerDetailProductPage = (data, hiredProductsList) => {
  const sectionsOrion = [];
  if (data?.fields?.["000_AP_MODULO_SERVICIOS_GRATUITOS"]?.fields) {
    const module = data?.fields?.["000_AP_MODULO_SERVICIOS_GRATUITOS"]?.fields;
    if (
      module["AP_ICON_TITLE"] &&
      Array.isArray(module["AP_ICON_TITLE"]) &&
      module["AP_ICON_TITLE"].length > 0
    ) {
      const normalizerServiceList = [];
      module["AP_ICON_TITLE"].map((item) => {
        if (item.fields) {
          const data = {
            icon: item?.fields?.icon,
            title: item?.fields?.title,
            href: item?.fields?.href1,
            href2: item?.fields?.href2,
          };
          normalizerServiceList.push(data);
        }
      });
      const info = {
        alias: data?.fields?.["000_AP_MODULO_SERVICIOS_GRATUITOS"]?.name,
        title: module?.title,
        list: normalizerServiceList,
      };
      sectionsOrion.push(info);
    }
  }
  if (
    data?.fields?.["001_AP_MODULO_OTRAS_GESTIONES"]?.fields ||
    data?.fields?.["002_AP_MODULO_OTRAS_GESTIONES"]?.fields ||
    data?.fields?.["004_AP_MODULO_OTRAS_GESTIONES"]?.fields
  ) {
    const module =
      data?.fields?.["001_AP_MODULO_OTRAS_GESTIONES"]?.fields ||
      data?.fields?.["002_AP_MODULO_OTRAS_GESTIONES"]?.fields ||
      data?.fields?.["004_AP_MODULO_OTRAS_GESTIONES"]?.fields;
    if (
      module?.faqsList &&
      Array.isArray(module?.faqsList) &&
      module?.faqsList.length > 0
    ) {
      const normalizerFaqsList = [];
      let linesMobile = null;
      if (hiredProductsList) {
        linesMobile = getMobilesProducts(hiredProductsList);
      }
      module.faqsList.map((item) => {
        if (item.fields) {
          if (
            linesMobile &&
            linesMobile.length > 1 &&
            item?.fields?.title === SERVICE_SHARED_DATA
          ) {
            const data = {
              href: item?.fields?.href,
              icon: item?.fields?.icon,
              srcSvg: item?.fields?.srcSvg,
              title: item?.fields?.title,
              subtitle: item?.fields?.subtitle,
              serviceType: item?.fields?.serviceType,
              modalContent: {
                alias: item?.fields?.modalContent?.alias,
                title: item?.fields?.modalContent?.title,
                data: item?.fields?.modalContent?.data?.fields,
              },
            };
            normalizerFaqsList.push(data);
          } else if (item?.fields?.title !== SERVICE_SHARED_DATA) {
            const data = {
              href: item?.fields?.href,
              icon: item?.fields?.icon,
              title: item?.fields?.title,
              subtitle: item?.fields?.subtitle,
              serviceType: item?.fields?.serviceType,
              modalContent: {
                alias: item?.fields?.modalContent?.alias,
                title: item?.fields?.modalContent?.title,
                data: item?.fields?.modalContent?.data?.fields,
              },
            };
            normalizerFaqsList.push(data);
          }
        }
      });
      const infoManagment = {
        alias:
          data?.fields?.["001_AP_MODULO_OTRAS_GESTIONES"]?.name ||
          data?.fields?.["002_AP_MODULO_OTRAS_GESTIONES"]?.name ||
          data?.fields?.["004_AP_MODULO_OTRAS_GESTIONES"]?.name,
        title: module?.title,
        list: normalizerFaqsList,
      };
      sectionsOrion.push(infoManagment);
    }
  }
  return sectionsOrion;
};

export const normalizeCustoCreativity = (data, module) => {
  const info = data?.fields?.[module]?.fields;
  if (info) {
    const titleSplited = info?.title.split("::");
    return {
      activityTitle: titleSplited[1],
      activitiesList: info?.activitiesList.map((activity) => {
        const splited = activity?.fields?.id.split("::");
        return {
          kind: splited[0],
          name: splited[1],
        };
      }),
    };
  } else {
    return null;
  }
};

const normalizeOrionFaqs = (data) => {
  const normalizedFaqs = [];
  let title = "";

  if (data) {
    const { listadoFAQS } = data;
    ({ title } = data);

    if (listadoFAQS && Array.isArray(listadoFAQS) && listadoFAQS.length > 0) {
      listadoFAQS.forEach(({ fields: faqItem }) => {
        if (faqItem.title && faqItem.description) {
          normalizedFaqs.push({
            title: faqItem.title,
            description: faqItem.description,
          });
        }
      });
    }
  }
  return {
    title: { ...mock["Text-1"], text: title },
    listadoFAQS: normalizedFaqs,
  };
};

const normalizerProviderActivation = (data, provider) => {
  const normalizeListByModules = {};
  let headerTitle = null;
  let imgDesktop = null;
  let listCard = null;
  let listBuyBox = null;
  let faqs = null;
  if (data?.fields) {
    const fields = data.fields;
    if (fields["001_MODULO_BANNER"]?.fields?.imgDesktop) {
      imgDesktop = fields["001_MODULO_BANNER"].fields.imgDesktop;
    }
    if (
      fields["003_MODULO_CARACTERISTICAS_CARDS"]?.fields
        ?.ListadoCaracteristicCard
    ) {
      const normalizerListCards = [];
      const listCards =
        fields["003_MODULO_CARACTERISTICAS_CARDS"].fields
          .ListadoCaracteristicCard;
      listCards.forEach((card) => {
        if (card?.fields) {
          const { description, icon, subTitle, title } = card.fields;
          const data = {
            title,
            subTitle,
            icon,
            description,
          };
          data && normalizerListCards.push(data);
        }
      });
      listCard = normalizerListCards;
    }
    if (fields["002_MODULO_BUYBOX_OPTIONS"]) {
      const normalizerBoxs = [];
      const buyBoxArray = fields["002_MODULO_BUYBOX_OPTIONS"];
      buyBoxArray.forEach((box) => {
        const { alias, fields } = box;
        const {
          caracteristics,
          href,
          legalError,
          legalModal,
          legalText,
          subTitle,
          textButton,
          title,
          topDescription,
          upDescription,
        } = fields;
        const data = {
          alias,
          caracteristics,
          href,
          legalError,
          legalModal,
          legalText,
          subTitle,
          textButton,
          title,
          topDescription,
          upDescription,
        };
        data && normalizerBoxs.push(data);
      });
      listBuyBox = normalizerBoxs;
    }
    if (
      Array.isArray(fields?.["004_MODULO_ACTIVACION_FAQS"]) &&
      fields?.["004_MODULO_ACTIVACION_FAQS"].length > 0
    ) {
      const fieldsFaqs = fields?.["004_MODULO_ACTIVACION_FAQS"].map((faqs) => ({
        alias: faqs.alias,
        ...normalizeOrionFaqs(faqs.fields),
      }));
      faqs = fieldsFaqs;
    }

    switch (provider) {
      case providers.dazn:
        headerTitle = provider.toUpperCase();
        break;
      case providers.max:
        headerTitle = "HBO Max";
        break;
      case providers.skyshowtime:
        headerTitle = "SkyShowtime";
        break;
      case providers.disney:
        headerTitle = "Disney+";
        break;
      default:
        headerTitle = capitalizeFirstLetter(provider);
        break;
    }
  }
  return { headerTitle, imgDesktop, listBuyBox, listCard, faqs };
};

const normalizerBillPage = (data) => {
  const sectionsOrion = [];
  if (
    data?.fields?.["001_AP_MODULO_OTRAS_GESTIONES"]?.fields ||
    data?.fields?.["002_AP_MODULO_OTRAS_GESTIONES"]?.fields ||
    data?.fields?.["004_AP_MODULO_OTRAS_GESTIONES"]?.fields
  ) {
    const module =
      data?.fields?.["001_AP_MODULO_OTRAS_GESTIONES"]?.fields ||
      data?.fields?.["002_AP_MODULO_OTRAS_GESTIONES"]?.fields ||
      data?.fields?.["004_AP_MODULO_OTRAS_GESTIONES"]?.fields;
    if (
      module?.faqsList &&
      Array.isArray(module?.faqsList) &&
      module?.faqsList.length > 0
    ) {
      const normalizerFaqsList = [];
      module.faqsList.map((item) => {
        if (item.fields) {
          const data = {
            href: item?.fields?.href,
            icon: item?.fields?.icon,
            srcSvg: item?.fields?.srcSvg,
            title: item?.fields?.title,
            serviceType: item?.fields?.serviceType,
            modalContent: {
              alias: item?.fields?.modalContent?.alias,
              title: item?.fields?.modalContent?.title,
              data: item?.fields?.modalContent?.data?.fields,
            },
          };
          normalizerFaqsList.push(data);
        }
      });
      const infoManagment = {
        alias:
          data?.fields?.["001_AP_MODULO_OTRAS_GESTIONES"]?.name ||
          data?.fields?.["002_AP_MODULO_OTRAS_GESTIONES"]?.name ||
          data?.fields?.["004_AP_MODULO_OTRAS_GESTIONES"]?.name,
        title: module?.title,
        subtitle: module?.subtitle,
        list: normalizerFaqsList,
      };
      sectionsOrion.push(infoManagment);
    }
  }
  return sectionsOrion;
};


export const normalizeSelfDiagnostic = (data) => {
  let normalizeInfo = null;
  const normalizeFieldsList = []
  if (data?.fields?.["001_MODULO_AUTODIAGNOSTICO_LIST"]) {
    const fields = data.fields["001_MODULO_AUTODIAGNOSTICO_LIST"]
    fields.map((item) => {
      if (item?.fields) {
        const itemFields = item.fields
        const { buttonText, description, href, idAutoDiagnostico, img, title } = itemFields
        const data =  {
          id: idAutoDiagnostico,
          title: title,
          description: description,
          image: img,
          href: href,
          button: buttonText,
        }
        normalizeFieldsList.push(data)
      }
    })
    normalizeInfo = {screens: normalizeFieldsList};
  }
  return normalizeInfo;
}

export const normalizeSelfDiagnosticCodes = (data) => {
  let normalizeInfo = null;
  const normalizeFieldsList = []
  if (data?.fields?.["001_MODULO_AUTODIAGNOSTICO_CODES"]) {
    const fields = data.fields["001_MODULO_AUTODIAGNOSTICO_CODES"]
    fields.map((item) => {
      if (item?.fields) {
        const itemFields = item.fields
        const { code, time} = itemFields
        const data =  {
          code: code,
          time: time && parseInt(time),
        }
        normalizeFieldsList.push(data)
      }
    })
    normalizeInfo = {codes: normalizeFieldsList};
  }
  return normalizeInfo;
}

export const normalizeDevicePage = (data) => {
  const sectionsOrion = [];
  if (data?.fields?.bannerList) {
    const bannerList = data.fields.bannerList;
    bannerList.map((banner) => {
      if (banner.fields) {
        const {
          claim,
          description,
          hrefButton,
          icon,
          labelButton,
          price,
          unit,
          idType,
          show,
        } = banner.fields;
        const bannerNormalizer = {
          id: idType,
          claim,
          description,
          hrefButton,
          icon,
          labelButton,
          price,
          unit,
          show: show,
        };
        sectionsOrion.push(bannerNormalizer);
      }
    });
  }
  return sectionsOrion;
}

export const normalizeModalInfo = (data) => {
  const sectionsOrion = [];
  if (data?.fields) {
    const fields = data.fields;
    const { button1, subtitle, title } = fields;
    sectionsOrion.push({ button: button1, subtitle, title });
  }
  return sectionsOrion;
};

const normalizedESim = (data) => {
  const normalizerFields = [];
  if (data?.fields?.["001_MODULO_LIST"]) {
    const fields = data.fields["001_MODULO_LIST"];
    fields.map((item) => {
      const { fields, alias } = item;
      if (fields) {
        const { buttonText, description, title, infoTitle, infoText } = fields;
        const data = {
          id: alias,
          title: title,
          description: description,
          infoTitle: infoTitle,
          infoText: infoText,
          buttonText: buttonText,
        };
        data && normalizerFields.push(data);
      }
    });
  } else {
    console.log("entra");
  }

  console.log(normalizerFields);
  return normalizerFields;
};

const normalizeEquipmentCards = (data) => {
  const normalizeCards = [];
  if (data?.fields?.listCard) {
    if (data?.fields?.listCard && Array.isArray(data?.fields?.listCard) && data?.fields?.listCard.length > 0) {
      data?.fields?.listCard.map((item) => {
        if (item?.fields) {
          normalizeCards.push(item?.fields);
        }
      })
    }
    const dataNormalize = {
      title: data?.fields?.title,
      cards: normalizeCards,
    }
    return dataNormalize;
  }
}

const normalizeCerberusInfo = (data) => {
  if (data?.fields?.["AP-PROTECCION-RED"]) {
    const fields = data?.fields?.["AP-PROTECCION-RED"];
    let dataNormalize = null;
    if (Array.isArray(fields) && fields.length > 0) {
      fields.forEach((item) => {
        const { title, description, serviceType, modalType } = item?.fields;
        dataNormalize = {
          ...dataNormalize,
          [serviceType]: { title, description, modalType }
        }
      })
    }
    return dataNormalize;
  }
}

const normalizeCerberusSummaryInfo = (data) => {
  const dataNormalize = null;
  const slotsNormalize = []
  if (data?.fields) {
    const fields = data?.fields;
    const { title } = fields;
    const fieldsArray = fields?.["AP-AMENAZAS"];
    if (Array.isArray(fieldsArray) && fieldsArray.length > 0) {
      fieldsArray.forEach((item) => {
        const { identificador, text, icon, modalType } = item?.fields;
        slotsNormalize.push({ id: identificador, title: text, icon, modalType })
      })
    }
    return { title, slotsNormalize };
  }
}

const normalizeSwapLegals = (data) => {
  const fields = data?.fields?.["AP-TEX-INFO"];

  if (!Array.isArray(fields)) return [];

  return fields
    .filter(item => item?.fields)
    .map(({ fields }) => ({
      id: fields.typeId,
      title: fields.title,
      text: fields.text
    }));
};

const normalizePagoDeudaAlert = (data) => {
  const fields = data?.fields;

  return fields || null;
}

const normalizeFastPass = (data) => {
  const { description, detail, textButton, title, urlButton, ["AP-MOVISTAR-FAST-PASS"]: fastPassList = [] } = data.fields || {};

  return {
    description,
    detail,
    textButton,
    title,
    urlButton,
    fastPass: fastPassList.map((item) => ({
      price: item.fields?.price || "",
      duration: item.fields?.duration || "",
      description: item.fields?.description || "",
    })),
  };
}

const normalizeHomeEsim = (data) => {
  const { footerText, title, description, icon } = data.fields || {};

  return {
    title,
    description,
    footerText,
    icon,
  };
}

export const normalizerOrion = (data, hiredProductsList) => {
  let normalizeInfo = null;
  let normalizeInfoCustoMejora = null;
  let normalizeInfoData = null;
  switch (data.name) {
    case "AP_GP_PAGE_PERFIL_AREA_PRIVADA_PERFIL":
      normalizeInfo = normalizeOrionInfoProfile(data, "000_AP_MODULO_PERFIL");
      break;
    case "AP_GP_PAGE_PERFIL_PASSWORD":
      normalizeInfo = normalizeOrionInfoProfile(data, "000_AP_ITEM_ARRAY");
      break;
    case "AP_GP_PAGE_PERFIL_GESTIONES_LINEAS":
      normalizeInfo = normalizeOrionInfoProfile(data, "000_AP_ITEM_ARRAY");
      break;
    case "AP_PAGE_PRODUCTOS_CONTRATADOS_MIS_PRODUCTOS":
      const normalizeInfoHiredProduct = normalizerHiredProductsOrion(
        data,
        "000_AP_MODULO_PRODUCTOS_CONTRATADOS",
        "AP_PRODUCTOS_CONTRATOS"
      );
      normalizeInfoCustoMejora = normalizeCustoCreativity(
        data,
        "001_AP_MODULO_MEJORA_TU_PACK"
      );
      const normalizeInfoCustoOtros = normalizeCustoCreativity(
        data,
        "002_AP_MODULO_OTROS_PRODUCTOS"
      );
      normalizeInfo = {
        normalizeInfoHiredProduct,
        normalizeInfoCustoMejora,
        normalizeInfoCustoOtros,
      };
      break;
    case "AP_PAGE_GESTIONES_DISTRIBUTIVA_DISTRI":
      normalizeInfo = normalizerManagamentPagesOrion(data, hiredProductsList);
      break;
    case "AP_GESTIONES_AREA_PRIVADA_FACTURAS":
      normalizeInfo = normalizerGeneralManagamentPagesOrion(data);
      break;
    case "AP_GESTIONES_AREA_PRIVADA_GESTIONES_DATOS_PERSONALES":
      normalizeInfo = normalizerGeneralManagamentPagesOrion(data);
      break;
    case "AP_GESTIONES_LINEA_MOVIL_AREA_PRIVADA":
      normalizeInfo = normalizerGeneralManagamentPagesOrion(data);
      break;
    case "AP_GESTIONES_LINEA_MOVIL_AREA_PRIVADA_PUK":
      normalizeInfo = normalizerGeneralManagamentPagesOrion(data);
      break;
    case "AP_PAGE_GESTIONES_INTERNET_AREA_PRIVADA":
      normalizeInfo = normalizerGeneralManagamentPagesOrion(data);
      break;
    case "AP_GESTIONES_TV_AREA_PRIVADA":
      normalizeInfo = normalizerGeneralManagamentPagesOrion(data);
      break;
    case "AP_PAGE_DETALLE_INTERNET_AREA_PRIVADA":
      normalizeInfoData = normalizerDetailProductPage(data);
      normalizeInfoCustoMejora = normalizeCustoCreativity(
        data,
        "001_AP_MODULO_MEJORA_PACK"
      );
      normalizeInfo = {
        normalizeInfo: normalizeInfoData,
        normalizeInfoCustoMejora,
      };
      break;
    case "AP_PAGE_DETALLE_SEGUNDA_FIBRA_AREA_PRIVADA":
      normalizeInfoData = normalizerDetailProductPage(data);
      normalizeInfoCustoMejora = normalizeCustoCreativity(
        data,
        "001_AP_MODULO_MEJORA_PACK"
      );
      normalizeInfo = {
        normalizeInfo: normalizeInfoData,
        normalizeInfoCustoMejora,
      };
      break;
    case "AP_PAGE_DETALLE_FIBRA_ADICIONAL_AREA_PRIVADA":
      normalizeInfoData = normalizerDetailProductPage(data);
      normalizeInfoCustoMejora = normalizeCustoCreativity(
        data,
        "001_AP_MODULO_MEJORA_PACK"
      );
      normalizeInfo = {
        normalizeInfo: normalizeInfoData,
        normalizeInfoCustoMejora,
      };
      break;
    case "AP_DETALLE_LINEA_FIJA_AREA_PRIVADA":
      normalizeInfoData = normalizerDetailProductPage(data);
      normalizeInfoCustoMejora = normalizeCustoCreativity(
        data,
        "003_AP_MODULO_MEJORA_TU_PACK"
      );
      normalizeInfo = {
        normalizeInfo: normalizeInfoData,
        normalizeInfoCustoMejora,
      };
      break;
    case "AP_PAGE_DETALLE_MOVIL_AREA_PRIVADA":
      normalizeInfoData = normalizerDetailProductPage(data);
      normalizeInfoCustoMejora = normalizeCustoCreativity(
        data,
        "002_AP_MODULO_MEJORA_TU_PACK"
      );
      normalizeInfo = {
        normalizeInfo: normalizeInfoData,
        normalizeInfoCustoMejora,
      };
      break;
    case "AP_PAGE_GESTIONES_CONSUMO_AREA_PRIVADA":
      normalizeInfo = normalizerDetailProductPage(data, hiredProductsList);
      break;
    case "AP_PAGE_GESTIONES_CONSUMO_AREA_PRIVADA":
      normalizeInfo = normalizerDetailProductPage(data, hiredProductsList);
      break;
    case "PAGE_AP_ACTIVACION_SKYSHOWTIME":
      normalizeInfo = normalizerProviderActivation(data, providers.skyshowtime);
      break;
    case "PAGE_AP_ACTIVACION_HBO_MAYO_2024":
      normalizeInfo = normalizerProviderActivation(data, providers.max);
      break;
    case "PAGE_AP_ACTIVACION_DAZN_JUNIO_2024":
      normalizeInfo = normalizerProviderActivation(data, providers.dazn);
      break;
    case "PAGE_AP_ACTIVACION_DISNEY_PLUS":
      normalizeInfo = normalizerProviderActivation(data, providers.disney);
      break;
    case "PAGE_AP_ACTIVACION_PERPLEXITY":
      normalizeInfo = normalizerProviderActivation(data);
      break;
    case "PAGE_AP_ACTIVACION_CHAT_GPT":
      normalizeInfo = normalizerProviderActivation(data);
      break;
    case "AP_DETALLE_MIS_PRODUCTOS_TV":
      normalizeInfo = {
        normalizeInfo: normalizeTvInfoPage(data),
        normalizeInfoOtrasGestiones: normalizerDetailProductPage(data),
      };
      break;
    case "AP_DETALLE_MIS_PRODUCTOS_TV_MIMO":
      normalizeInfo = {
        normalizeInfo: normalizeTvInfoPage(data),
        normalizeInfoOtrasGestiones: normalizerDetailProductPage(data),
      };
      break;
    case "AP_GESTIONES_FACTURAS_AREA_PRIVADA":
      normalizeInfo = normalizerBillPage(data);
      break;
    case "AP_GESTIONES_FACTURAS_AREA_PRIVADA_DETALLE_FACTURAS":
      normalizeInfo = normalizerBillPage(data);
      break;
    case "AP_DETALLE_SALUD":
      normalizeInfoData = normalizerDetailProductPage(data);
      normalizeInfo = {
        normalizeInfo: normalizeInfoData[0],
      };
      break;
    case "AP_DETALLE_ALARMAS":
      normalizeInfoData = normalizerDetailProductPage(data);
      normalizeInfo = {
        normalizeInfo: normalizeInfoData[0],
      };
      break;
    case "AP_DETALLE_GAME_PASS":
      normalizeInfoData = normalizerDetailProductPage(data);
      normalizeInfo = {
        normalizeInfo: normalizeInfoData[0],
      };
      break;
    case "AP_PAGE_AUTODIAGNOSTICO":
      normalizeInfo = normalizeSelfDiagnostic(data);
      break;
    case "AP_PAGE_AUTODIAGNOSTICO_CODE":
      normalizeInfo = normalizeSelfDiagnosticCodes(data);
      break;
    case "AP_DETALLE_MIS_PRODUCTOS_SEGUROS_CARD":
      normalizeInfoData = normalizerDetailProductPage(data);
      normalizeInfo = {
        normalizeInfo: normalizeInfoData[0],
      };
      break;
    case "AP_DETALLE_MIS_PRODUCTOS_MOVISTAR_CARD_PROTECT":
      normalizeInfoData = normalizerDetailProductPage(data);
      normalizeInfo = {
        normalizeInfo: normalizeInfoData[0],
      };
      break;
    case "AP_MIS_DISPOSITIVOS":
      normalizeInfo = normalizeDevicePage(data);
      break;
    case "AP_MODAL_CONTENT":
      normalizeInfo = normalizeModalInfo(data);
      break;
    case "PAGE_AP_ESIM_LIST":
      normalizeInfo = normalizedESim(data);
      break;
    case "AP_CARD_COLLECTION":
      normalizeInfo = normalizeEquipmentCards(data);
      break;
    case "AP-PROTECCION-RED":
      normalizeInfo = normalizeCerberusInfo(data);
      break;
    case "AP-AMENAZAS-DETECTADAS":
      normalizeInfo = normalizeCerberusSummaryInfo(data);
      break;
    case "AP_ICON_TITLE_DESCRIPTION":
       normalizeInfo = normalizePagoDeudaAlert(data);
      break;
    case "TEX-INFO":
      normalizeInfo = normalizeSwapLegals(data);
      break;
    case "AP-MOVISTAR-FAST":
      normalizeInfo = normalizeFastPass(data);
      break;
    case "AP-MODAL-ESIM":
      normalizeInfo = normalizeHomeEsim(data);
      break;
    default:
      break;
  }
  switch (true) {
    case data.name.includes("AP_PAGE_GESTIONES_LINEA_FIJA"):
      normalizeInfo = normalizerGeneralManagamentPagesOrion(data);
      break;
    default:
      break;
  }
  return normalizeInfo;
};

export const normalizerPorductCharacteristicsOrion = (data, alias) => {
  const characteristicsOrion = [];
  if (data?.fields?.["AREA_PRIVADA_CARACTERISTICS"]?.fields) {
    const module = data?.fields?.["AREA_PRIVADA_CARACTERISTICS"]?.fields;
    const normalizerCharacteristicsList = [];
    if (module?.caracteristicsList[0]?.fields?.["AP_CARACTERISTICS"]) {
      const listCharacteristicsModule =
        module?.caracteristicsList[0]?.fields?.["AP_CARACTERISTICS"];
      if (
        listCharacteristicsModule &&
        Array.isArray(listCharacteristicsModule) &&
        listCharacteristicsModule.length > 0
      ) {
        listCharacteristicsModule.map((item) => {
          const field = {
            title: item?.fields?.title,
            description: item?.fields?.description,
            icon: item?.fields?.icon,
          };
          normalizerCharacteristicsList.push(field);
        });
      }
    }
    characteristicsOrion.push({
      title: module?.title,
      characteristics: normalizerCharacteristicsList,
      poId: alias,
    });
  }
  return characteristicsOrion;
};

export const normalizeTvInfoPage = (data) => {
  let tvPackages = null;
  let tvButtons = null;
  let tvPlatforms = null;
  let tvHeader = null;
  if (data?.fields?.["000_AP_MODULO_PAQUETES_CONTRATADOS"]?.fields?.title) {
    const {buttonText, href, title } = data.fields["000_AP_MODULO_PAQUETES_CONTRATADOS"].fields;
    tvHeader = { buttonText, href, title }
  }

  if (data?.fields?.["001_AP_MODULO_PAQUETES_TV"]?.fields?.title) {
    tvPackages = {
      title: data.fields["001_AP_MODULO_PAQUETES_TV"].fields.title,
      subTitle: data.fields["001_AP_MODULO_PAQUETES_TV"].fields.subTitle,
      href: data.fields["001_AP_MODULO_PAQUETES_TV"].fields.href,
    };
  }
  if (
    Array.isArray(
      data?.fields?.["002_AP_MODULO_BUTTON"]?.fields?.hreftitleList
    ) &&
    data?.fields?.["002_AP_MODULO_BUTTON"]?.fields?.hreftitleList.length > 0
  ) {
    tvButtons = {
      title: data?.fields?.["002_AP_MODULO_BUTTON"]?.fields?.title,
      buttons: data?.fields?.[
        "002_AP_MODULO_BUTTON"
      ]?.fields?.hreftitleList.map((button) => button.fields),
    };
    tvButtons.buttons.forEach((button, index) => {
      if (button.href === "" && button.modalContent) {
        tvButtons.buttons[index].modalContent =
          button.modalContent.data.fields["001_MODULO_MODAL"].fields;
      }
    });
  }
  if (data?.fields?.["003_AP_MODULO_PLATAFORMAS"]?.fields?.title) {
    tvPlatforms = {
      title: data.fields["003_AP_MODULO_PLATAFORMAS"].fields.title,
    };
  }

  return {
    tvHeader,
    tvPackages,
    tvButtons,
    tvPlatforms,
  };
};

export const getTextByName = (pills, contentType) => {
  let TextByName = "";
  if (pills.find((x) => x.type === contentType)) {
    TextByName = pills.find((x) => x.type === contentType);
  }

  return TextByName;
};

export const getTextsListByName = (pills, contentType) => {
  let TextByName = "";
  if (pills.find((x) => x.type === contentType)) {
    TextByName = pills.filter((x) => x.type === contentType);
  }

  return TextByName;
};
